import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useAuthStore } from '../store/authStore';
import { useTranslate } from '../i18n';
import { translateApiError } from '../i18n/translations';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const { login, isLoading } = useAuthStore();
  const t = useTranslate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await login(username, password);
      navigate('/chat');
    } catch (err) {
      setError(translateApiError(err.response?.data?.error) || t('error'));
    }
  };

  return (
    <div className="min-h-dvh bg-canvas flex">
      <aside className="hidden lg:flex w-[42%] flex-col justify-between bg-nest text-ink p-12">
        <p className="text-sm font-semibold">{t('appName')}</p>
        <div>
          <img
            src="/apple-touch-icon.png"
            alt=""
            width={64}
            height={64}
            className="mb-8 h-16 w-16 rounded-3xl shadow-float bg-white object-cover"
          />
          <h1 className="text-5xl font-bold leading-tight tracking-tight max-w-sm">
            {t('familySubtitle')}
          </h1>
          <p className="mt-6 text-lg text-ink-muted max-w-sm leading-relaxed">{t('familyPitch')}</p>
        </div>
        <p className="text-sm text-ink-muted">{t('privateNote')}</p>
      </aside>

      <main className="flex-1 flex items-center justify-center p-4 sm:p-8">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center lg:text-start">
            <img
              src="/apple-touch-icon.png"
              alt=""
              width={56}
              height={56}
              className="lg:hidden mx-auto mb-4 h-14 w-14 rounded-[1.25rem] shadow-float bg-white object-cover"
            />
            <p className="lg:hidden text-ink font-bold text-lg mb-1">{t('appName')}</p>
            <h2 className="text-2xl font-bold text-ink">{t('welcomeBack')}</h2>
          </div>

          <div className="nest-card p-6 sm:p-8">
            {error && (
              <div
                role="alert"
                className="mb-5 rounded-2xl bg-red-50 text-red-700 px-4 py-3 text-sm"
              >
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label htmlFor="username" className="block text-sm font-medium text-ink mb-2">
                  {t('username')}
                </label>
                <input
                  id="username"
                  type="text"
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck="false"
                  dir="ltr"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="nest-input bg-canvas focus:bg-white"
                  placeholder={t('usernamePlaceholder')}
                />
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-ink mb-2">
                  {t('password')}
                </label>
                <div className="relative">
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                    dir="ltr"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="nest-input bg-canvas focus:bg-white pe-12"
                    placeholder="••••••"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((v) => !v)}
                    className="absolute inset-y-0 end-0 icon-btn"
                    aria-label={showPassword ? t('hidePassword') : t('showPassword')}
                  >
                    {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full min-h-[52px] rounded-2xl bg-primary text-white font-bold cursor-pointer hover:opacity-90 active:scale-[0.99] transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-float"
              >
                {isLoading ? t('processing') : t('login')}
              </button>
            </form>
          </div>

          <a
            href="http://185.206.95.192/dl/ashiiane.mobileconfig"
            className="mt-4 block text-center text-sm text-ink-muted hover:text-ink"
          >
            افزودن آیکون لانه
          </a>
        </div>
      </main>
    </div>
  );
}
